
import { useQuery, useMutation} from '@tanstack/react-query'
import { 
        // fetchMemberships,
        addPaymentSetupIntent,
        // addPayIntent,
        deletePaymentMethod,
        fetchPaymentMethods,
        fetchPaymentHistory,
     } from '../api/crud'
import {AccountSchema } from "../data/types";


const staleTime = 1000
const isEnabled = true

export const useGetPaymentMethods = (uid: string) => {
    const {
        data: paymentMethods,
        refetch: reloadPaymentMethods,
        isLoading: isLoadingPaymentMethods,
        isFetching: isFetchingPaymentMethods,
    } = useQuery({ 
        queryKey: ['payMethods', uid], 
        queryFn: async () => {
            console.log("fetching payMethods")
            const res = await fetchPaymentMethods(uid)
            return res ? res : []
        },
        staleTime,
        enabled: !!uid && isEnabled
    })

    const getPaymentMethod = (account: AccountSchema) => {
        let paymentMethodId = account.payment_method
        return paymentMethods.find((obj: any) => obj['id'] === paymentMethodId);
    }

    return { isLoadingPaymentMethods, isFetchingPaymentMethods, paymentMethods, getPaymentMethod, reloadPaymentMethods}
}


export const useAddPaySetupIntent = (uid: string, communityId?: string) => {
    // const { reloadPaymentMethods } = useGetPaymentMethods(uid)

    const mutation = useMutation({ 
        mutationFn: async () => {
            console.log("add setup intent")
            const res = await addPaymentSetupIntent(uid, communityId)
            // console.log("addPaymentSetupIntent res: ", res)
            if (!res) {
                throw new Error("Failed to create setup intent: API returned null")
            }
            const {client_secret} = res
            // await reloadPaymentMethods()
            return client_secret
        },
        // cacheTime: 10000
    })

    const addSetupIntent = async (): Promise<string | undefined> => {
        try {
            const clientSecret = await mutation.mutateAsync()
            return clientSecret
        } catch (error) {
            if (process.env.NODE_ENV !== 'test') {
                console.error("Error adding setup intent:", error)
            }
            return undefined
        }
    }

    const deletePayMethodMutation = useMutation({ 
        mutationFn: async (paymentMethodId: string) => {
            console.log("delete payment method")
            const res = await deletePaymentMethod(paymentMethodId)
            const { deleted } = res
            // await reloadPaymentMethods()
            return deleted ?  deleted : false
        },
        // onSuccess: async () => {
        //     await reloadPaymentMethods()
        // }
        // cacheTime: 10000
    })

    const removePaymentMethod = async (paymentMethodId: string) => {
        const result = await deletePayMethodMutation.mutateAsync(paymentMethodId)
        return result
    }


    const isLoadingSetupIntent = mutation.isPending || deletePayMethodMutation.isPending
    return { addSetupIntent, removePaymentMethod, isLoadingSetupIntent }
}


export const useGetPaymentHistory = (uid: string) => {
    const {
        data: paymentHistory,
        refetch: reloadPaymentHistory,
        isLoading: isLoadingPaymentHistory,
        isFetching: isFetchingPaymentHistory,
    } = useQuery({ 
        queryKey: ['payHistory', uid], 
        queryFn: async () => {
            const res = await fetchPaymentHistory(uid)
            // console.log("fetchPaymentHistory res: ", res)
              // Sample data matching the image
            // const res: PaymentHistoryItemSchema[] = [
            //     { id: "01", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            //     { id: "02", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "pending" },
            //     { id: "03", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "refunded" },
            //     { id: "04", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "failed" },
            //     { id: "05", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            //     { id: "06", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            //     { id: "07", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            //     { id: "08", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            //     { id: "09", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            //     { id: "10", resourceName: "Eatsplace", amount: 12, paymentMethod: "Master Card", cardNumber: "**** 1234", transactionId: "123456789123", date: "06/06/2025", status: "completed" },
            // ];
            return res ? res : []
        },
        staleTime,
        enabled: !!uid && isEnabled
    })

    return { paymentHistory, reloadPaymentHistory, isLoadingPaymentHistory, isFetchingPaymentHistory }
}   